import React from "react";
import Button from "../ui/Button";
import EditText from "../ui/EditText";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-auto bg-[#1c233a]  ">
      <div className=" max-w-[1700px] mx-auto">
        <div className="relative w-auto h-auto">
          {/* Main content */}
          <div className="relative z-10 p-[20px] sm:p-[30px] 2xl:py-[40px]">
            <div className="ml-[0px] sm:ml-[40px] 2xl:ml-[54px]">
              <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-[84px]  w-auto">
                {/* Left Section - Company Info & Social */}
                <div className="flex flex-col gap-[12px] sm:gap-[18px] 2xl:gap-[24px] justify-start items-start w-auto lg:w-[30%]">
                  {/* Logo Section */}
                  <Link to="/" className="relative block">
                    <div className="flex 2xl:justify-start 2xl:items-center gap-[10px] w-full ">
                      <div className="relative">
                        <img
                          src="/images/BottomLogo.webp"
                          alt="Company LogoCircle"
                          className=" w-[50px] h-[50px] 2xl:w-auto 2xl:h-auto animate-spin-slow" // <<<--- **HERE IS THE CHANGE**
                        />
                        <div className="absolute top-0">
                          <img
                            src="/images/TopLogo.webp"
                            alt="Company LogoCircle"
                            className=" w-[50px] h-[50px] 2xl:w-auto 2xl:h-auto " // <<<--- **HERE IS THE CHANGE**
                          />
                        </div>
                      </div>
                      <div className="flex justify-center items-center ">
                        <img
                          src="/images/logoText.png"
                          alt="Company Logo"
                          className="hidden md:block 2xl:w-auto 2xl:h-auto"
                        />
                      </div>
                    </div>
                  </Link>
                  {/* Description */}
                  <p className="text-[16px] mb-[20px] md:mb-[50px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] 2xl:leading-[38px] text-left text-white font-[Sora] w-full">
                    Sustaining Life, Energising Future
                  </p>

                  {/* Social Media Icons */}
                  <div className="flex gap-[10px] sm:gap-[15px] 2xl:gap-[20px] justify-start items-center w-auto">
                    <Link
                      to="https://www.youtube.com/channel/UC0I2wlFUc9IkXHKtxIg71gA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Facebook"
                      >
                        <img
                          src="/images/youtube.svg"
                          alt="youtube"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[32px] 2xl:h-[32px]"
                        />
                      </button>
                    </Link>
                    <Link
                      to="https://www.instagram.com/utpann_organic_fertilizer/#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Facebook"
                      >
                        <img
                          src="/images/insta.svg"
                          alt="Facebook"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[32px] 2xl:h-[32px]"
                        />
                      </button>
                    </Link>
                    <Link
                      to="https://www.facebook.com/utpannorganicfertilizer/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Twitter"
                      >
                        <img
                          src="/images/faceBook.svg"
                          alt="Twitter"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[32px] 2xl:h-[32px]"
                        />
                      </button>
                    </Link>
                    <Link
                      to="https://www.linkedin.com/company/govardhannathji-energies-llp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="LinkedIn"
                      >
                        <img
                          src="/images/in.svg"
                          alt="LinkedIn"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[30px] 2xl:h-[30px]"
                        />
                      </button>
                    </Link>
                    <Link
                      to="https://x.com/utpann_in"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Instagram"
                      >
                        <img
                          src="/images/x.svg"
                          alt="Instagram"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[32px] 2xl:h-[32px]"
                        />
                      </button>
                    </Link>
                  </div>
                </div>

                {/* Right Section - Contact Details & Newsletter */}
                <div className="flex flex-wrap  justify-between lg:flex-nowrap gap-8 lg:gap-[50px] w-auto lg:w-auto">
                  {/* Contact Details */}

                  {/* Center Section - Quick Links */}
                  <div className="flex flex-col justify-start items-start w-auto lg:w-[20%]">
                    <h3 className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                      Quick Links
                    </h3>
                    <a
                      href="/about"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[12px] sm:mt-[18px] 2xl:mt-[24px] hover:opacity-75 transition-opacity"
                    >
                      About Us
                    </a>
                    <a
                      href="/products"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[8px] sm:mt-[12px] 2xl:mt-[16px] hover:opacity-75 transition-opacity"
                    >
                      Products
                    </a>
                    <a
                      href="/biogas-plant"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[8px] sm:mt-[12px] 2xl:mt-[16px] hover:opacity-75 transition-opacity"
                    >
                      Biogas Plant
                    </a>
                    <a
                      href="https://blog.govardhannathjienergies.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[10px] sm:mt-[15px] 2xl:mt-[20px] hover:opacity-75 transition-opacity"
                    >
                      Blog
                    </a>
                    <a
                      href="/contact"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[7px] sm:mt-[10px] 2xl:mt-[14px] hover:opacity-75 transition-opacity"
                    >
                      Contact Us
                    </a>
                  </div>
                  <div className="flex flex-col gap-[11px] sm:gap-[16px] 2xl:gap-[22px] justify-start items-start w-auto lg:w-[40%]">
                    <h3 className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                      Contact Details
                    </h3>

                    <ul className="flex flex-col justify-start items-start w-auto space-y-4">
                      <li>
                        <a
                          href="tel:+918645888881"
                          className="flex gap-[9px] sm:gap-[14px] 2xl:gap-[18px] justify-start items-center w-auto hover:opacity-75 transition-opacity"
                        >
                          <img
                            src="/images/callIcon.svg"
                            alt="Phone"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] 2xl:w-[30px] 2xl:h-[30px]"
                          />
                          <span className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                            +91 86 45 88 88 81
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="mailto:info@utpann.in"
                          className="flex gap-[9px] sm:gap-[14px] 2xl:gap-[18px] justify-start items-center w-auto hover:opacity-75 transition-opacity mt-[12px] sm:mt-[18px] 2xl:mt-[24px]"
                        >
                          <img
                            src="/images/EmailIcon.svg"
                            alt="Email"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] 2xl:w-[30px] 2xl:h-[30px] self-start"
                          />
                          <span className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                            info@utpann.in
                          </span>
                        </a>
                      </li>
                      <li>
                        <div className="flex gap-[9px] sm:gap-[14px] 2xl:gap-[18px] justify-start items-start w-auto mt-[7px] sm:mt-[10px] 2xl:mt-[14px]">
                          <img
                            src="/images/locationIcon.svg"
                            alt="Address"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] 2xl:w-[30px] 2xl:h-[30px]"
                          />
                          <p className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] 2xl:leading-[38px] text-left text-white font-[Sora] self-center w-[90%]">
                            Sr. No. 2373, Sim Vistar, At & Po-Pij, Ta-Vaso,
                            <br />
                            Dist-Kheda, Gujarat INDIA 387230
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* Newsletter Subscription */}
                  <div className="hidden flex-col gap-[10px] sm:gap-[15px] 2xl:gap-[20px] justify-start items-start w-auto lg:w-[34%]">
                    <h3 className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                      Subscribe to Our Newsletter
                    </h3>

                    <EditText
                      placeholder="Enter your mail"
                      text_font_size="14"
                      text_font_family="Sora"
                      text_font_weight="400"
                      text_line_height="18px"
                      text_text_align="start"
                      text_color="#ffffff7f"
                      border_border="1px solid #ffffff"
                      border_border_radius="30px"
                      padding="7px 15px"
                      className="w-full text-[14px] sm:text-[17px] 2xl:text-[20px] leading-[18px] sm:leading-[22px] 2xl:leading-[26px] py-[7px] px-[15px] sm:py-[10px] sm:px-[22px] 2xl:py-[14px] 2xl:px-[30px]"
                    />

                    <Button
                      text="Submit"
                      text_font_size="16"
                      text_font_family="Sora"
                      text_font_weight="700"
                      text_line_height="20px"
                      text_text_align="center"
                      text_color="#1c233a"
                      fill_background_color="#7abf6b"
                      border_border_radius="30px"
                      border_border="none"
                      padding="6px 17px"
                      className="w-auto text-[16px] sm:text-[20px] 2xl:text-[24px] leading-[20px] sm:leading-[25px] 2xl:leading-[31px] py-[6px] px-[17px] sm:py-[9px] sm:px-[25px] 2xl:py-[12px] 2xl:px-[34px]"
                    />
                  </div>

                  {/* WhatsApp Support Section */}
                  <div className="flex flex-col justify-start items-start max-w-[320px]">
                    {/* Card Container */}
                    <div className="bg-[#242d48] p-5 sm:p-6 rounded-2xl w-full border border-white/5 shadow-xl">
                      {/* Header with Icon */}
                      <div className="flex items-center gap-3 mb-3">
                        <div className="bg-[#25D366] p-1.5 rounded-lg shadow-lg shadow-[#25d366]/20">
                          <svg
                            viewBox="0 0 24 24"
                            className="w-6 h-6 fill-white"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.886 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                          </svg>
                        </div>
                        <h3 className="text-[18px] sm:text-[22px] font-bold text-white font-[Parkinsans]">
                          WhatsApp Support
                        </h3>
                      </div>

                      {/* Description */}
                      <p className="text-[14px] sm:text-[16px] text-white/80 font-[Parkinsans] mb-6 leading-snug">
                        Chat with our team <br /> for quick assistance.
                      </p>

                      {/* Chat Button */}
                      <div className="">
                        <a
                          href="https://wa.me/918645888881"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-center w-[auto] py-3 px-6 bg-[#25D366] hover:bg-[#20ba5a] text-white font-bold rounded-full transition-all duration-300 transform hover:scale-[1.02] active:scale-95 text-[16px] sm:text-[18px]"
                        >
                          Chat Now
                        </a>
                      </div>
                      {/* Status and Time */}
                      <div className="mt-4 flex items-center gap-2">
                        <div className="flex items-center gap-1.5">
                          <span className="relative flex h-3 w-3">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                          </span>
                          <span className="text-[12px] sm:text-[14px] text-white/70 font-medium">
                            Online
                          </span>
                        </div>
                        <span className="text-white/40 text-[12px]">•</span>
                        <span className="text-[12px] sm:text-[14px] text-white/70">
                          Mon-Sat: 9 AM-6 PM
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Background watermark text */}
          <div className="  flex items-end justify-center z-0">
            <img
              src="/images/contactFooter.webp"
              alt="Watermark Text"
              className="w-auto"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
